export const A11Y_HEADING_FOCUS_ID = 'a11y-heading-focus-id';
